export const types = {
  state: {
    TOKEN: 'token',
    HASHED_DATA_ID: 'hashedDataId',
    INITIAL_PAGE_DATA: 'initialPageData',
    PATIENT_SKIN_DATA: 'patientSkinData',
    SERUM_INCI_LISTS: 'serumInciLists',
    DYSFUNCTIONS_DATA: 'dysfunctionsData',
    DELIVERY_DATA: 'deliveryData',
    DELIVERY_TYPE: 'deliveryType',
    LOCALE: 'locale',
    IS_LOADING: 'isLoading',
    AVAILABLE_DELIVERY_COUNTRIES: 'availableDeliveryCountries',
    PROMO_CODE_DATA: 'promoCodeData',
    DOCTOR_SLUG: 'doctorSlug',
    SELECTED_EYE_SERUM_GENERIC_FORMULA_ID: 'selectedEyeSerumGenericFormulaId',
    TRUSTPILOT_DATA: 'trustpilotData',
    TRUSTPILOT_REVIEWS: 'trustpilotReviews',

    /* Cart */
    CART: 'cart',
    IS_CART_OPEN: 'isCartOpen',

    /* Stocks */
    TREATMENT_DATA: 'treatmentData',
    EYE_CONTOUR_SERUM_GENERIC_FORMULAS_LIST: 'eyeContourSerumGenericFormulasList',
    RECOMMENDED_PRODUCT_NAMES: 'recommendedProductNames',
    PRICES: 'prices',
    STOCK: 'stock'
  },
  getters: {
    DOCTOR_FULL_NAME: 'doctorFullName',
    TREATMENT_ID: 'treatmentId',
    ORDER_ID: 'orderId',
    HAS_DYSFUNCTIONS: 'hasDysfunctions',
    GET_IS_PRODUCT_RECOMMENDED: 'getIsProductRecommended',
    HAS_INGREDIENTS_IN_SERUMS: 'hasIngredientsInSerums',
    IS_ANY_SERUM_RECOMMENDED: 'isAnySerumRecommended',
    MAIN_PAGE_SECTIONS: 'mainPageSections',
    TOTAL_ORDER_COST: 'totalOrderCost',
    TOTAL_COST_WITHOUT_DISCOUNT: 'totalCostWithoutDiscount',
    SCORES: 'scores',
    FOOTER_LINKS: 'footerLinks',
    DOES_TREATMENT_CONTAIN_EYE_SERUM_GENERIC: 'doesTreatmentContainEyeSerumGeneric',
    EYE_SERUM_GENERIC_FORMULA_IDS: 'eyeSerumGenericFormulaIds',
    GET_PRODUCT_PACK_BY_REFERENCE: 'getProductPackByReference',

    /* Delivery */
    DELIVERY_COUNTRY: 'deliveryCountry',
    MIN_DELIVERY_PRICE: 'minDeliveryPrice',
    CART_PRICE_RESIDUE_BY_SERUM_INCLUSION: 'cartPriceResidueBySerumInclusion',
    CART_PRICE_RESIDUE: 'cartPriceResidue',
    HAS_FREE_DELIVERY: 'hasFreeDelivery',
    CLASSIC_DELIVERY_DATA: 'classicDeliveryData',
    EXPRESS_DELIVERY_DATA: 'expressDeliveryData',
    AVAILABLE_DELIVERY_TYPES: 'availableDeliveryTypes',
    DELIVERY_COST: 'deliveryCost',
    FREE_DELIVERY_MESSAGE_CONFIG: 'freeDeliveryMessageConfig',
    GET_FREE_DELIVERY_MESSAGE_CONFIG: 'getFreeDeliveryMessageConfig',
    GET_IF_CUSTOM_FEE_WARNING_MUST_BE_SHOWN: 'getIfCustomFeeWarningsMustBeShown',
    GET_SHIPPING_PAYMENT_INFO: 'getShippingPaymentInfo',
    IS_MULTICOUNTRY_DELIVERY_AVAILABLE: 'isMulticountryDeliveryAvailable',
    HAS_PAYPAL_PAY_LATER_OPTION: 'hasPaypalPayLaterOption',
    LOCALE_WITH_REGION: 'localeWithRegion',

    /* Cart */
    CART_PRODUCTS_COUNT: 'cartProductsCount',
    GET_IS_PRODUCT_ADDED_TO_CART_BY_NAME: 'getIsProductNameAddedToCartByName',
    GET_IS_PRODUCT_PACK_ADDED_TO_CART: 'getIsProductPackAddedToCart',
    GET_PRODUCT_FROM_CART: 'getProductFromCart',
    CART_PRICE: 'cartPrice',
    HAS_SERUM_IN_CART: 'hasSerumInCart',
    CART_ITEMS: 'cartItems',

    /* Stocks */
    CURRENCY: 'currency',

    ALL_PRODUCT_OPTIONS_SETS: 'allProductOptionsSets',
    ALL_PRODUCT_PACKS_LIST: 'allProductPacksList',
    RECOMMENDED_PRODUCT_OPTIONS_SETS: 'recommendedProductOptionsSets'
  },
  mutations: {
    RESET_STORE: 'resetStore',
    SET_TOKEN: 'setToken',
    SET_HASHED_DATA_ID: 'setHashedDataId',
    SET_INITIAL_PAGE_DATA: 'setInitialPageData',
    SET_PATIENT_SKIN_DATA: 'setPatientSkinData',
    SET_SERUM_INCI_LISTS: 'setSerumInciLists',
    SET_DYSFUNCTIONS_DATA: 'setDysfunctionsData',
    SET_DELIVERY_DATA: 'setDeliveryData',
    UPDATE_DELIVERY_TYPE: 'updateDeliveryType',
    SET_LOCALE: 'setLocale',
    UPDATE_IS_LOADING_STATUS: 'updateIsLoadingStatus',
    SET_DOCTOR_SLUG: 'setDoctorSlug',
    SET_AVAILABLE_DELIVERY_COUNTRIES: 'setAvailableDeliveryCountries',
    UPDATE_PROMO_CODE_DATA: 'updatePromoCodeData',
    SET_SELECTED_EYE_SERUM_GENERIC_FORMULA_ID: 'setSelectedEyeSerumGenericFormulaId',
    SET_TRUSTPILOT_DATA: 'setTrustpilotData',
    SET_TRUSTPILOT_REVIEWS: 'setTrustpilotReviews',

    /* Cart */
    TOGGLE_OPEN_CART: 'toggleOpenCart',
    SET_IS_CART_OPEN: 'setIsCartOpen',
    EMPTY_CART: 'emptyCart',
    SET_CART: 'setCart',

    /* Stocks */
    SET_EYE_CONTOUR_SERUM_GENERIC_FORMULAS_LIST: 'setEyeContourSerumGenericFormulasList',
    SET_TREATMENT_DATA: 'setTreatmentData',
    SET_RECOMMENDED_PRODUCT_NAMES: 'setRecommendedProductNames',
    SET_PRICES: 'setPrices',
    SET_STOCK: 'setStock'
  },
  actions: {
    AUTHENTICATE: 'authenticate',
    FETCH_INITIAL_PAGE_DATA: 'fetchInitialPageData',
    FETCH_WEBSHOP_DATA: 'fetchWebshopData',
    GET_INCI_LISTS: 'getInciLists',
    FETCH_UPDATABLE_WEBSHOP_DATA: 'fetchUpdatableWebshopData',
    FETCH_STOCK_INFO: 'fetchStockInfo',
    FETCH_DELIVERY_DATA: 'fetchDeliveryData',
    SET_LOCALE: 'setLocale',
    SET_DELIVERY_COUNTRY: 'setDeliveryCountry',
    UPDATE_TREATMENT_DATA_WITH_RENEWED_OFFER: 'updateTreatmentDataWithRenewedOffer',
    ENSURE_PROMO_CODE_VALIDITY: 'ensurePromoCodeValidity',

    /* Cart */
    SET_PRODUCT_QUANTITY_IN_CART: 'setProductQuantityInCart',
    PUT_PRODUCT_PACK_IN_CART_OR_OPEN_CART: 'putProductPackInCartOrOpenCart',
    PREFILL_CART: 'prefillCart',
    PUT_CART_ITEM_IN_CART: 'putCartItemInCart',
    REMOVE_CART_ITEM_FROM_CART: 'removeCartItemFromCart',
    MAKE_ORDER: 'makeOrder',
    GET_TRUSTPILOT_DATA: 'getTrustpilotData',
    GET_TRUSTPILOT_REVIEWS: 'getTrustpilotReviews',

    GET_TREATMENT_DTO_FOR_SAVE_CART_REQUEST: 'getTreatmentDtoForSaveCartRequest',

    LOAD_SITE_DATA: 'loadSiteData'
  }
};
